import { jsx } from 'react/jsx-runtime';

// eslint-disable-next-line import/no-default-export -- Icon
function BoltWithOutline({ className, "data-testid": testId, }) {
    return (jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", className: className, "data-testid": testId, children: jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30 16C30 23.732 23.732 30 16 30C8.26801 30 2 23.732 2 16C2 8.26801 8.26801 2 16 2C23.732 2 30 8.26801 30 16ZM32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16ZM10.1074 17.335L17.5096 5.05273L15.9004 14.0115H21.6934L14.2913 26.2938L15.9004 17.335H10.1074Z", fill: "#219653" }) }));
}

export { BoltWithOutline as default };
//# sourceMappingURL=BoltWithOutline.js.map
